import React, { useState } from "react";
import { Select } from "antd";

const MySelectDropdown = ({
  options,
  placeholder = "Select",
  onChange,
  ...rest
}) => {
  // const [value, setValue] = useState();
  const handleChange = (value) => {
    console.log(`selected ${value}`);
    // setValue(value);
    onChange(value);
  };

  // console.log(options, " = mySelectDropDown");

  return (
    <Select
      // mode="tags"
      style={{
        width: "100%",
        borderRadius: "16px",
      }}
      size="large"
      // value={value}
      placeholder={placeholder}
      showSearch
      options={options}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default MySelectDropdown;
